// Card Logos
export const amex = require('./amex.svg');
export const diners = require('./diners.svg');
export const discover = require('./discover.svg');
export const jcb = require('./jcb.svg');
export const mastercard = require('./mastercard.svg');
export const visa = require('./visa.svg');
export const generic = require('./generic.svg');
